import React from 'react';

export interface UserData {
  birthDate: Date | null;
  includeTime: boolean;
  birthPlace: string;
  coordinates: { lat: number; lng: number } | null;
  lifeExpectancy: number;
  timezone: string;
}

export type Mood = 'Calm' | 'Confused' | 'Excited' | 'Anxious' | null;

export interface ReadingRecord {
    date: string;
    timestamp: number;
    cardId: number;
    reversed: boolean;
    note?: string;
}

export interface GeneratedProfile {
  headline: string;
  quote: string;
  luckyColor: string;
  luckyNumber: number;
  traits: string[];
  socialBlurb: string;
  analysis: string;
}

export interface AppSettings {
  soundEnabled: boolean;
  nightMode: boolean; // Dream mode
  tarotCollection: number[]; // Array of Card IDs
  lastDailyReadingDate: string | null; // ISO Date string (YYYY-MM-DD)
  dailyCardId: number | null;
  dailyCardReversed: boolean;
  lastTarotPickTimestamp: number | null;
  lastOracleAskTimestamp: number | null;
  lastOracleResponse: string | null; // Persist the last answer
  currentMood: Mood;
  unlockedSpreads: string[]; // Track which spreads user has unlocked
  // Spread Cooldown & Persistence
  lastSpreadPickTimestamp: number | null;
  lastSpreadCards: { id: number; reversed: boolean }[] | null;
  lastSpreadRevealed: boolean[] | null;
  // Reflection Cooldown & Persistence
  lastReflectionTimestamp: number | null;
  lastReflectionContent: string | null;
  // Compatibility Cooldown & Persistence
  lastCompatibilityTimestamp: number | null;
  lastCompatibilityResult: { love: string; work: string; friend: string } | null;
  // Personality Cooldown & Persistence
  lastPersonalityTimestamp: number | null;
  lastPersonalityProfile: GeneratedProfile | null;
  // Timeline Cooldown
  lastTimelineTimestamp: number | null;
  // Monetization & History
  readingHistory: ReadingRecord[];
}

export enum ZodiacSign {
  Aries = "Aries",
  Taurus = "Taurus",
  Gemini = "Gemini",
  Cancer = "Cancer",
  Leo = "Leo",
  Virgo = "Virgo",
  Libra = "Libra",
  Scorpio = "Scorpio",
  Sagittarius = "Sagittarius",
  Capricorn = "Capricorn",
  Aquarius = "Aquarius",
  Pisces = "Pisces"
}

export enum ChineseZodiacSign {
  Rat = "Rat",
  Ox = "Ox",
  Tiger = "Tiger",
  Rabbit = "Rabbit",
  Dragon = "Dragon",
  Snake = "Snake",
  Horse = "Horse",
  Goat = "Goat",
  Monkey = "Monkey",
  Rooster = "Rooster",
  Dog = "Dog",
  Pig = "Pig"
}

export interface AgeDetail {
  years: number;
  months: number;
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  totalMonths: number;
  totalWeeks: number;
  totalDays: number;
  totalHours: number;
  totalSeconds: number;
  totalMilliseconds: number;
}

export interface NavigationItem {
  label: string;
  path: string;
  icon: React.ReactNode;
}